import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { initLocomotiveScroll, destroyLocomotiveScroll } from './scroll'
import { updateLocomotiveModals } from './shared/locomotive-modals'
import { windowUpdate, removeReCaptchaBadge, blueimpGalleryDestroy } from './shared/common'
import { buildOwl, destroyOwl } from './shared/owlcarousel'
// controllers
import Controller from './controllers/Controller'
import ModstatsController from './controllers/ModstatsController'
import MapsController from './controllers/MapsController'
// views
import BasicView from './views/BasicView'
import ListView from './views/ListView'

const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'modstats': {
    controller: ModstatsController,
    view: null
  },
  'map': {
    controller: MapsController,
    view: null
  },
}

const aswapProps = {
  animationTimeHide: 500,
  animationTimeShow: 500,
  preloadOnHover: false,
  cacheOn: true,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged()
    blueimpGalleryDestroy()
    windowUpdate()
    buildOwl()
    updateLocomotiveModals()
    RytmWebflow.showUp.rebuild()
  },
  onViewShow: () => {
    setTimeout(initLocomotiveScroll, 50)
    // initLocomotiveScroll()
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
    destroyLocomotiveScroll()
  },
  onViewHidden: () => {
    destroyOwl()
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}